import React, { Component } from 'react';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Draggable, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Table, Breadcrumb, Tabs, Tab } from 'react-bootstrap';
import { Link } from 'react-router';
import { Field } from 'redux-form';
import Select from 'react-select';
import { UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import GroupForm from '../../containers/Products/groupForm';
import Categories from '../../containers/Products/categories';
import Category_2 from '../../containers/Products/category_2';
import Category_2_B2B from '../../containers/Products/category_2_b2b';
import PackageTypes from '../../containers/Products/packageTypes';
import MeasurementUnit from '../../containers/Products/measurementUnit';
import DrayageList from '../../containers/Products/drayageList';
import checkPermission from '../Common/permissions';
import Category2Detail from '../../containers/Products/Category2Detail';
import Category2B2BDetail from '../../containers/Products/Category2B2BDetail';
import ImageFormatter from '../Common/ImageFormatter';

import { Translate, Localize } from 'react-redux-i18n';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isElegant } from '../../actions/root_url';
import GroupImageManageModal from './components/GroupImageManageModal';

const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afg-scm.truckxi.com/api/';
const isEcity = ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_URL === 'https://ctstage-scm.truckxi.com/api/';
const isHF = ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || ROOT_URL === 'https://hfstage-erp.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';
const isKDW = ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
const isSUNNY = ROOT_API_URL === 'https://sunny-scm.truckxi.com/api/';

const { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer } = Draggable;
const { Selectors } = Data;
const RowRenderer = DropTargetRowContainer(ReactDataGrid.Row);

class Groups extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };
  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,
      renderCategories: true,
      tabKey: 1,

      rows: [],
      selectedRows: null,
      editedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      groupOpen: false,
      imageManagementModalVisibility: false,
      imageManageIndex: null,
      imageManageRow: null,
    };

    this.handleResize = this.handleResize.bind(this);
    this.openGroup = this.openGroup.bind(this);
    this.closeGroup = this.closeGroup.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.renderImage = this.renderImage.bind(this);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    if(isElegant) {
      this.props.fetchGroupsElegant();
    } else {
      this.props.fetchGroups();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.groups && nextProps.groups != this.props.groups) {
      const { groups } = nextProps;
      let index = 0;
      groups.map((group) => {
        group.Index = index++;
      });
      this.setState({
        rows: groups,
      });
    }
    // if successfully edited, refresh table
    if ((nextProps.multiEdited && nextProps.multiEdited != this.props.multiEdited)) {
      if(isElegant) {
        this.props.fetchGroupsElegant();
      } else {
        this.props.fetchGroups();
      }
      this.setState({
        selectedRows: null,
        editedRows: [],
      });
    }
    // //display success messages
    // if (nextProps.deleteGroupSuccess) {
    //   alert('deleted');
    // }
    // if (nextProps.multiEdited) {
    //   alert('saved');
    // }

    // display error messages
    if (nextProps.multiError && !this.props.multiError) {
      alert(nextProps.multiError);
    }
    if (nextProps.deleteGroupError && !this.props.deleteGroupError) {
      alert(nextProps.deleteGroupError);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this.props.clearDeleteGroupStatus();
  }

  onDrop(row, files) {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const index = row.props.rowIdx;
      const newRows = [...this.state.rows];
      const editedRows = [...this.state.editedRows];
      newRows[index].Image = reader.result;
      const editedRowIndex = _.findIndex(editedRows, r => r.Index === row.props.dependentValues.Index);
      if (editedRowIndex === -1) {
        editedRows.push(newRows[index]);
      } else {
        editedRows.splice(editedRowIndex, 1);
        editedRows.push(newRows[index]);
      }
      this.setState({ rows: newRows, editedRows });
    };
    // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
    const blob = files[0].slice(0, files[0].size, files[0].type);
    reader.readAsDataURL(blob);
  }

  handleImageManagement = index => {
    this.setState({
      imageManagementModalVisibility: true,
      imageManageIndex: index,
      imageManageRow: this.state.rows[index]
    });
  }

  closeImageManagementModal = () => {
    this.setState({
      imageManagementModalVisibility: false,
      imageManageIndex: null,
      imageManageRow: null,
    });
  }

  handleImageManageConfirm = (data) => {
    this.state.rows[this.state.imageManageIndex] = data;
    this.setState({
      rows: [...this.state.rows]
    });
    this.closeImageManagementModal();
  }

  handleResize(e) {
    this.setState({
      tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,
    });
  }

  handleSelect(tabKey) {
    this.setState({ tabKey })
  }

  updateRows(e) {
    e.preventDefault();
    if(isElegant) {
      this.props.editMultiGroupsElegant(this.state.rows);
    } else {
      this.props.editMultiGroups(this.state.rows);
    }
  }

  deleteGroup(e) {
    e.preventDefault();
    const productGroupId = this.state.selectedRows[0].ProductGroup_id;
    if (productGroupId) {
      this.props.deleteGroup(productGroupId);
    } else {
      const rows = [...this.state.rows];
      const editedRows = [...this.state.editedRows];
      let index = _.findIndex(rows, { Index: this.state.selectedRows[0].Index })
      rows.splice(index, 1);
      index = _.findIndex(editedRows, { Index: this.state.selectedRows[0].Index })
      editedRows.splice(index, 1);
      this.setState({ rows, editedRows, selectedRows: [] });
    }
  }

  openGroup() { this.setState({ groupOpen: true }); }
  closeGroup() { this.setState({ groupOpen: false }); }

  // Helper function to render an icon for the stock statues of product.
  renderIsEnabled(IsEnabled) {
    if (IsEnabled) return <span className="label label-success"><Translate value="is_enabled"/></span>;
    return <span className="label label-danger"><Translate value="disabled"/></span>;
  }

    // Set the group being selected to be currentGroup and navigate user to the edit page

    // setCurrentGroup(e) {
    //     e.preventDefault();
    //     const currentGroup = this.state.selectedRows[0];
    //     this.props.selectGroup(currentGroup);
    //     this.openGroup();
    // }

    clickNew(e) {
        e.preventDefault();
        this.setState({sortColumn: null, sortDirection: null})
        // this.props.resetCurrentGroup();
        // this.openGroup();
        let rows = Selectors.getRows(this.state);
        let index = rows.length;
        let newRow = {Name: null, Description: null, IsEnabled: true, Index: index};
        rows.push(newRow);
        let editedRows = [...this.state.editedRows];
        editedRows.push(newRow)
        this.setState({rows, editedRows})
    }

    renderImage(index) {
      let imageFile = (this.state.rows[index].Image || '/img/dummy.png');
      return (
        <div className="group-img-view">
          <img
            src={imageFile}
            alt="Upload"
          />
        </div>
      );
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
    renderTable() {
        if (this.props.groupIsLoading && !this.props.groupError) return <Spinner/>
        else if (this.props.groupError) return <ContentWrapper><div className="alert alert-danger">{this.props.groupError.message}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }


            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                this.setState({sortColumn: null, sortDirection: null})
                let rows = getRows();
                let editedRows = this.state.editedRows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                // if the element is already edited, remove the old one.
                editedRows.forEach((element, index) => {
                    if (element.Idx === rows[e.rowIdx].Index)
                        editedRows.splice(index, 1)
                }, this);
                // push the row into the editedRows array
                editedRows.push(rows[e.rowIdx]);
                this.setState({
                    rows: rows,
                    editedRows: editedRows
                });
            }

            // Handle the Dragable cell function

            const handleCellDrag = e => {
                let rows = this.state.rows.slice(0);
                let editedRows = this.state.editedRows.slice(0);
                for (let i = e.fromRow; i <= e.toRow; i++) {
                    let rowToUpdate = rows[i];
                    rowToUpdate[e.cellKey] = e.value;
                    // if the element is already edited, remove the old one.
                    editedRows.forEach((element, index) => {
                        if (element.ProductGroup_id === rowToUpdate.ProductGroup_id)
                            editedRows.splice(index, 1)
                    }, this);
                    // push the row into the editedRows array
                    editedRows.push(rowToUpdate);
                }
                this.setState({
                    rows: rows,
                    editedRows: editedRows
                });
            }

            const handleDragHandleDoubleClick = e => {
                var rows = this.state.rows.map(function (r) {
                    return Object.assign({}, r);
                });
                let editedRows = this.state.editedRows.slice(0);
                var column = columns[e.Index - 1];
                for (var i = e.rowIdx; i <= rows.length - 1; i++) {
                    var rowToUpdate = rows[i];
                    rowToUpdate[column.key] = e.rowData[column.key];
                    // if the element is already edited, remove the old one.
                    editedRows.forEach((element, index) => {
                        if (element.ProductGroup_id === rowToUpdate.ProductGroup_id)
                            editedRows.splice(index, 1)
                    }, this);
                    // push the row into the editedRows array
                    editedRows.push(rowToUpdate);
                }
                this.setState({ rows: rows });
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                  return (
                    <input
                      id="product-group-enable"
                      type="checkbox"
                      value="true"
                      checked={this.props.value == true || this.props.value == "true"}
                      onClick={()=>{handleIsEnabledClick(this.props)}}/>
                  )
                }
            });

            const handleEnableLaguangeChange = (newVal, dependentValues) => {
              const currentRows = [...this.state.rows];
              currentRows[dependentValues.Index].ViewableLanguages = newVal;
              this.setState({
                rows: currentRows,
              })
            }

            const EnabledLanguageFormatter = React.createClass({
              render() {
                const {
                  value,
                  options,
                  dependentValues,
                } = this.props;
                
                const backupOptions = [
                  {
                    label: 'English - EN',
                    value: 'EN',
                  },
                  {
                    label: 'Chinese - ZH',
                    value: 'ZH',
                  },
                ];
                return (
                  <div id="zInd" style={{ position: 'relative', height: '82px' }}>
                    <Select
                      matchPos={"start"}
                      matchProp={'label'}
                      menuPortalTarget={document.body}
                      styles={{
                        // Fixes the overlapping problem of the component
                        menu: provided => ({ ...provided, zIndex: 9999 })
                      }}
                      options={options || backupOptions}
                      value={value}
                      onChange={newVal => handleEnableLaguangeChange(newVal, dependentValues)}
                      multi
                      removeSelected
                      simpleValue
                      closeOnSelect={false}
                    />
                  </div>
                )
              }
            })

            // const enabledLanguageFormatter = React.create

            const handleIsEnabledClick = (isEnabled) => {
              let rows = getRows();
              let index = _.findIndex(rows, {Index: isEnabled.dependentValues.Index});
              rows[index].IsEnabled = !(rows[index].IsEnabled);
              let editedRows = [...this.state.editedRows];
              editedRows.map((row, idx) => {
                  if (row.Index === rows[index].Index)
                      editedRows.splice(idx, 1)
              });
              editedRows.push(rows[index])
              this.setState({rows, editedRows});
            }

            // Handle the row select function

            // const onRowSelect = rows => {
            //     this.setState({ selectedRows: rows });
            // }

            const onRowsSelected = (rows, calledFromOtherFunction) => {
              !calledFromOtherFunction && onRowClick(rows[0].rowIdx, rows[0].row, true)
                 let newRows = getRows();
                 newRows.map(r => {
                   r.isSelected = false;
                 })
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = true;
                 });
                 this.setState({ rows: newRows, selectedRows: [rows[0].row] });
                }

             const onRowsDeselected = (rows) => {
                 let newRows = getRows();
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = false;
                 });
                 this.setState({rows: newRows, selectedRows: []});
             }

            const onRowClick = (rowIdx, row, calledFromOtherFunction) => {
              !calledFromOtherFunction && onRowsSelected([{rowIdx, row}], true)
              if(rowIdx > -1 && row.ProductGroup_id) {
                this.props.selectGroup(row.ProductGroup_id)
                this.props.fetchGroupCategories(row.ProductGroup_id)
              }
            }

            const isDraggedRowSelected = (selectedRows, rowDragSource) => {
              if (selectedRows && selectedRows.length > 0) {
                const key = this.props.rowKey;
                return selectedRows.filter(r => r[key] === rowDragSource.data[key]).length > 0;
              }
              return false;
            };

            const reorderRows = (e) => {
              const selectedRows = Selectors.getSelectedRowsByKey({ rowKey: this.props.rowKey, selectedKeys: [], rows: this.state.rows });
              const draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
              const undraggedRows = this.state.rows.filter(r => draggedRows.indexOf(r) === -1);
              const args = [e.rowTarget.idx, 0].concat(draggedRows);
              Array.prototype.splice.apply(undraggedRows, args);
              undraggedRows.map((row, index) => {
                row.Index = index;
              });
              console.log(undraggedRows);
              this.setState({ rows: undraggedRows });
            };

            // Column difinition

            const columns = [
                {
                    key: 'Group Image',
                    name: <Translate value={isJTB ? "img" : "group"} />,
                    resizable: true,
                    sortable: false,
                    editable: false,
                    filterable: false,
                    width: 220,
                    formatter: (
                      <ImageFormatter
                        renderImage={this.renderImage}
                        onDrop={this.onDrop}
                        showImageOnly
                        onImageManagement={this.handleImageManagement}
                      />
                    ),
                    getRowMetaData: row => row,
                },
                {
                    key: 'Name',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    editable: true,
                    filterable: true,
                    width: 160,
                },
                {
                    key: 'Description',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    editable: true,
                    filterable: true,
                    width: 160,
                },
                {
                    key: 'IsEnabled',
                    name: <Translate value="enabled" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    formatter: IsEnabledFormatter,
                    getRowMetaData: (row) => row,
                    width: 80,
                },
                ...isEcity ? [{
                  key: 'ViewableLanguages',
                  name: <Translate value="enable_for_languages" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  formatter: EnabledLanguageFormatter,
                  getRowMetaData: (row) => row,
                  width: 280,
                }] : {},
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="Groups-dataGrid1">
                  <DraggableContainer>
                    <ReactDataGrid
                        enableCellSelect={true}
                        onGridSort={handleGridSort}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={620}
                        rowHeight={120}
                        headerRowHeight={25}
                        enableRowSelect='single'
                        onDragHandleDoubleClick={handleDragHandleDoubleClick}
                        onCellsDragged={handleCellDrag}
                        onRowUpdated={handleRowUpdated}
                        rowSelection={{
                          showCheckbox: true,
                          onRowsSelected,
                          onRowsDeselected,
                          selectBy: {
                            isSelectedKey: 'isSelected'
                          }
                        }}
                        // onRowClick={onRowClick}
                        rowRenderer={<RowRenderer onRowDrop={reorderRows} />}
                        rowActionsCell={RowActionsCell}
                    />
                  </ DraggableContainer>
                </div></Col></Row>
            )
        }
    }

    formTitle() {
        if (this.props.currentGroup) return <Translate value="edit_group"/>;
        else return <Translate value="add_a_new_group" />;
    }

    categoryHeader() {
      return <Translate value="category"/>
    }

    renderDetail() {
      if (this.state.tabKey === 1) {
        return (
          <Panel header={this.categoryHeader()} className="category-panel">
            <Field component={Categories} />
          </Panel>
        );
      } else if (this.state.tabKey === 2) {
        this.props.resetCategory2Id();
        return (
          <Category2Detail
          />
        );
      } else if (this.state.tabKey === 5) {
        this.props.resetCategory2Id();
        return (
          <Category2B2BDetail
          />
        );
      }
      return <div />;
    }

    render() {
        return (
          //---------------
          // Begin HTML: Create New/Edit product_groups
          //---------------
          <ContentWrapper>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Translate value="general_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value={isJTB ? "customer_groups" : "product_group"}/>
              </Breadcrumb.Item>
            </Breadcrumb>
              {/* <div className="content-heading"><Translate value="product_groups"/></div> */}
              <br/>
              <Row>
                <Col sm={6}>
                  <Tabs activeKey={ this.state.tabKey } justified onSelect={this.handleSelect}>
                    <Tab eventKey={ 1 } title={<Translate value={isJTB ? "customers" : "group"}/>} className="group-tab">
                      <ButtonToolbar className="group-management-table-buttons">
                          <Button
                              bsStyle="primary"
                              className="buttonStyle"
                              onClick={(event) => { this.clickNew(event) } }
                              disabled={!checkPermission("add_product_group")}
                          >
                              <em className="fa fa-plus marginRightStyle" /><Translate value="create"/>
                          </Button>
                          <Button
                              bsStyle="success"
                              className="buttonStyle"
                              onClick={(event) => { this.updateRows(event) } }
                              disabled={!this.state.editedRows || !checkPermission("change_product_group")}>{}<em className="fa fa-save marginRightStyle" /><Translate value="save"/>
                          </Button>
                          <Button
                            bsStyle="danger"
                            className="buttonStyle"
                            onClick={(event) => { this.deleteGroup(event)}}
                            disabled={!this.state.selectedRows || this.state.selectedRows.length != 1 || !checkPermission("delete_product_group")}
                            ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                          </Button>
                      </ButtonToolbar>
                      {this.renderTable() }
                      <SkyLightStateless isVisible={this.state.imageManagementModalVisibility} onCloseClicked={this.closeImageManagementModal} title={'Group Images'}>
                        <GroupImageManageModal row={this.state.imageManageRow} onConfirm={this.handleImageManageConfirm}/>
                      </SkyLightStateless>
                      <SkyLightStateless isVisible={this.state.groupOpen} onCloseClicked={() => { this.closeGroup() } } title={this.formTitle() }>
                          <GroupForm closeG={this.closeGroup} />
                      </SkyLightStateless>
                      <br/>
                        {/* {
                          this.props.multiIsEditing &&
                          <div className="alert alert-info groups-saving-info"><span className=""><Translate value="saving"/></span></div>
                        }
                        {
                          this.props.multiEdited &&
                          <div className="alert alert-success groups-saving-info">
                            <span className=""><Translate value="saved" /></span>
                          </div>
                        }
                        {
                          this.props.deletingGroup &&
                          <div className="alert alert-info groups-saving-info"><span className=""><Translate value="deleting"/></span></div>
                        }
                        {
                          this.props.deleteGroupSuccess &&
                          <div className="alert alert-success groups-saving-info">
                            <span className=""><Translate value="deleted"/></span>
                          </div>
                        }
                        {
                          this.props.deleteGroupError &&
                          <div className="alert alert-danger groups-saving-info">
                            <span className="">{this.props.deleteGroupError}</span>
                          </div>
                        } */}
                    </Tab>
                  {
                    <Tab eventKey={2} title={isAFG || isSUNNY || isHF ? <Translate value="category_2_b2c" /> : <Translate value="category_2" />} className="category-2-tab">
                      <Field component={Category_2} />
                    </Tab>
                  }
                  {
                    (isAFG || isSUNNY || isHF) &&
                    <Tab eventKey={5} title={<Translate value="category_2_b2b" />} className="category-2-b2b-tab">
                      <Field component={Category_2_B2B}/>
                  </Tab>
                  }                 
                    <Tab eventKey={ 3 } title={<Translate value="pkg_size_1"/>} className="package-type-tab">
                      <Field component={PackageTypes}/>
                    </Tab>
                    <Tab eventKey={ 4 } title={<Translate value="pkg_size_2"/>} className="measurement-unit-tab">
                      <Field component={MeasurementUnit}/>
                    </Tab>
                    {
                      (isMAG || isKDW) &&
                    <Tab eventKey={ 6 } title={<Translate value="address_list"/>} className="drayage-tab">
                      <Field component={DrayageList}/>
                    </Tab>
    }
                  </Tabs>
                </Col>
                <Col sm={6}>
                  {this.renderDetail()}
                </Col>
              </Row>
          </ContentWrapper>
        );
    }
}

export default Groups;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/groups.jsx